import type { CitizenRequest } from './demandes'
import { liveCollection, materials } from './collectes'

/** Requête ouverte par ATNA quand le bac n'a pas été vidé après le passage du camion. */
export const binRequestReference = '#REQ-2947'

const materialLabel = materials[liveCollection.material].label

export const binRequest: CitizenRequest = {
  id: 'req-2947',
  reference: binRequestReference,
  title: `Bac non ramassé — ${materialLabel}`,
  service: 'Travaux publics',
  category: 'Collecte des matières résiduelles',
  address: '366, chemin Lakeshore',
  fullAddress: '366, chemin Lakeshore, Beaconsfield, Québec, H9W 4S4',
  submittedOn: 'Envoyée aujourd’hui',
  createdOn: '06/10/26',
  resolvedOn: null,
  createdBy: 'ATNA',
  status: 'recue',
  description: `Le bac de ${materialLabel.toLowerCase()} n’a pas été ramassé lors de la collecte du jour (${liveCollection.sector}, ${liveCollection.truck}). Le bac est resté au bord de la rue.`,
  attachments: [],
  timeline: [
    { date: 'Aujourd’hui', label: 'Requête ouverte par ATNA' },
    { date: 'Aujourd’hui', label: 'Transmise à la Ville de Beaconsfield' },
  ],
  messages: [
    {
      id: 'msg-2947-1',
      author: 'ville',
      authorName: 'Ville de Beaconsfield',
      sentAt: 'Aujourd’hui',
      body: 'Merci pour votre signalement. Un rattrapage est prévu dans les 48 heures ouvrables. Laissez votre bac au bord de la rue d’ici là.',
    },
  ],
}
